import {
  FaUserCheck,
  FaChalkboardTeacher,
  FaUserGraduate,
  FaUserFriends,
  FaTasks,
  FaClipboardList,
  FaFileDownload,
  FaPen,
  FaEdit,
  FaSignInAlt,
  FaKey,
  FaCheckCircle,
  FaBell,
  FaGraduationCap,
  FaClipboard,
} from "react-icons/fa";

export const reportPages = [
  {
    path: "/approval",
    match: "exact",
    title: "講師ログイン承認",
    icon: <FaUserCheck />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/notify",
    match: "exact",
    title: "お知らせ管理",
    icon: <FaBell />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/teachers",
    match: "exact",
    title: "講師管理",
    icon: <FaChalkboardTeacher />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/students",
    match: "exact",
    title: "生徒管理",
    icon: <FaUserGraduate />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/parents",
    match: "exact",
    title: "保護者管理",
    icon: <FaUserFriends />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/assignments",
    match: "exact",
    title: "担当生徒管理",
    icon: <FaTasks />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/reports",
    match: "exact",
    title: "報告書一覧",
    icon: <FaClipboardList />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/reports/edit",
    match: "startsWith",
    title: "報告書確認",
    icon: <FaEdit />,
    showInSidebar: false,
    visibleTo: ["admin"],
  },
  {
    path: "/reports/download",
    match: "exact",
    title: "PDFダウンロード",
    icon: <FaFileDownload />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/notifications",
    match: "exact",
    title: "お知らせ",
    icon: <FaBell />,
    showInSidebar: true,
    visibleTo: ["teacher"],
  },
  {
    path: "/select-students",
    match: "exact",
    title: "生徒選択",
    icon: <FaUserGraduate />,
    showInSidebar: true,
    visibleTo: ["teacher"],
  },
  {
    path: "/report",
    match: "exact",
    title: "授業報告入力",
    icon: <FaPen />,
    showInSidebar: true,
    visibleTo: ["teacher"],
  },
  {
    path: "/karte",
    match: "exact",
    title: "カルテ",
    icon: <FaClipboard />,
    showInSidebar: true,
    visibleTo: ["admin", "teacher"],
  },
  {
    path: "/goal",
    match: "exact",
    title: "課題",
    icon: <FaCheckCircle />,
    showInSidebar: true,
    visibleTo: ["admin", "teacher"],
  },
  {
    path: "/curriculums",
    match: "exact",
    title: "カリキュラム",
    icon: <FaGraduationCap />,
    showInSidebar: true,
    visibleTo: ["admin", "teacher"],
  },
  {
    path: "/",
    match: "exact",
    title: "ログイン",
    icon: <FaSignInAlt />,
    showInSidebar: false,
    visibleTo: ["admin", "teacher"],
  },
  {
    path: "/welcome",
    match: "exact",
    title: "パスワード登録",
    icon: <FaKey />,
    showInSidebar: false,
    visibleTo: ["admin", "teacher"],
  },
];
